import { merchantService } from '@/services/merchant.service'
import type {
    MerchantRecord,
    MerchantSummary,
    PlanRecord,
    PlanSummary,
    StoreRecord,
    StoreSummary,
} from '@/types/dashboard'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

const INITIAL_MERCHANTS: MerchantRecord[] = [
  {
    id: 1,
    name: 'أحمد علي',
    code: 'M0001XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 5,
    plan: 'starter',
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 2,
    name: 'خالد محمد',
    code: 'M0002XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'professional',
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 3,
    name: 'رامي أشرف',
    code: 'M0003XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'professional',
    createdAt: '21/4/2026',
    status: 'pending',
    enabled: true,
  },
  {
    id: 4,
    name: 'محمد خضر',
    code: 'M0004XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'starter',
    createdAt: '21/4/2026',
    status: 'inactive',
    enabled: false,
  },
  {
    id: 5,
    name: 'سمر رمضان',
    code: 'M0005XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'starter',
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 6,
    name: 'سحر رمضان',
    code: 'M0006XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'professional',
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 7,
    name: 'محمد خضر',
    code: 'M0007XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'professional',
    createdAt: '21/4/2026',
    status: 'inactive',
    enabled: false,
  },
  {
    id: 8,
    name: 'سمر رمضان',
    code: 'M0008XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'starter',
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 9,
    name: 'سحر رمضان',
    code: 'M0009XX',
    email: 'example@email.com',
    phone: '+966 12567956',
    activePlans: 3,
    plan: 'starter',
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
]

const INITIAL_STORES: StoreRecord[] = [
  {
    id: 1,
    name: 'الإلكترونيات الراقية',
    merchantName: 'أحمد محمد',
    domain: 'smart-electronics.shopsze.com',
    category: 'electronics',
    productsCount: 245,
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 2,
    name: 'أزياء',
    merchantName: 'أحمد محمد',
    domain: 'smart-electronics.shopsze.com',
    category: 'clothing',
    productsCount: 245,
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 3,
    name: 'متجر الكتب العربية',
    merchantName: 'أحمد محمد',
    domain: 'smart-electronics.shopsze.com',
    category: 'books',
    productsCount: 245,
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 4,
    name: 'إكسسوارات',
    merchantName: 'أحمد محمد',
    domain: 'smart-electronics.shopsze.com',
    category: 'home',
    productsCount: 245,
    createdAt: '21/4/2026',
    status: 'inactive',
    enabled: false,
  },
  {
    id: 5,
    name: 'أزياء',
    merchantName: 'أحمد محمد',
    domain: 'smart-electronics.shopsze.com',
    category: 'clothing',
    productsCount: 245,
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 6,
    name: 'الإلكترونيات',
    merchantName: 'أحمد محمد',
    domain: 'smart-electronics.shopsze.com',
    category: 'electronics',
    productsCount: 245,
    createdAt: '21/4/2026',
    status: 'active',
    enabled: true,
  },
  {
    id: 7,
    name: 'إكسسوارات أساسية',
    merchantName: 'أحمد محمد',
    domain: 'smart-electronics.shopsze.com',
    category: 'home',
    productsCount: 245,
    createdAt: '21/4/2026',
    status: 'inactive',
    enabled: false,
  },
]

const INITIAL_PLANS: PlanRecord[] = [
  {
    id: 1,
    name: 'الباقة الأساسية',
    price: 99,
    billing: 'monthly',
    subscribers: 245,
    status: 'active',
    enabled: true,
  },
  {
    id: 2,
    name: 'الباقة الاحترافية',
    price: 299,
    billing: 'monthly',
    subscribers: 156,
    status: 'active',
    enabled: true,
  },
  {
    id: 3,
    name: 'باقة المؤسسات',
    price: 599,
    billing: 'monthly',
    subscribers: 189,
    status: 'inactive',
    enabled: false,
  },
  {
    id: 4,
    name: 'الباقة السنوية الأساسية',
    price: 99,
    billing: 'yearly',
    subscribers: 401,
    status: 'active',
    enabled: true,
  },
  {
    id: 5,
    name: 'الباقة السنوية الاحترافية',
    price: 99,
    billing: 'yearly',
    subscribers: 356,
    status: 'active',
    enabled: true,
  },
  {
    id: 6,
    name: 'الباقة السنوية للمؤسسات',
    price: 99,
    billing: 'yearly',
    subscribers: 500,
    status: 'inactive',
    enabled: false,
  },
]

export const useDashboardStore = defineStore('dashboard', () => {
  const merchants = ref<MerchantRecord[]>(INITIAL_MERCHANTS)
  const stores = ref<StoreRecord[]>(INITIAL_STORES)
  const plans = ref<PlanRecord[]>(INITIAL_PLANS)
  const productsCount = ref<number>(0)

  const merchantSummary = computed<MerchantSummary>(() => ({
    total: 20,
    active: 8,
    pending: 4,
    inactive: 2,
  }))

  const storeSummary = computed<StoreSummary>(() => ({
    total: stores.value.length,
    active: stores.value.filter((store) => store.status === 'active').length,
    pending: stores.value.filter((store) => store.status === 'pending').length,
    inactive: stores.value.filter((store) => store.status === 'inactive').length,
  }))

  const planSummary = computed<PlanSummary>(() => ({
    total: 12,
    subscribers: 1847,
    monthlyRevenue: 24580,
  }))

  function setMerchantEnabled(id: number, enabled: boolean) {
    const merchant = merchants.value.find((item) => item.id === id)
    if (!merchant) return
    merchant.enabled = enabled
  }

  function setStoreEnabled(id: number, enabled: boolean) {
    const store = stores.value.find((item) => item.id === id)
    if (!store) return
    store.enabled = enabled
  }

  function setPlanEnabled(id: number, enabled: boolean) {
    const plan = plans.value.find((item) => item.id === id)
    if (!plan) return
    plan.enabled = enabled
  }

  async function fetchProductsSummary() {
    try {
      const { data } = await merchantService.getSummary()
      productsCount.value = data.data.products_count
    } catch {
      // keep default 0
    }
  }

  return {
    merchants,
    stores,
    plans,
    productsCount,
    merchantSummary,
    storeSummary,
    planSummary,
    setMerchantEnabled,
    setStoreEnabled,
    setPlanEnabled,
    fetchProductsSummary,
  }
})